// Generated by scripts/icons/build-icon-components.mjs from the matching
// file in ./svg — edit the SVG and re-run the script, not this file.
import SvgIcon, { type SvgIconProps } from '@mui/material/SvgIcon';

const HabilitationIcon = (props: SvgIconProps) => (
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <g fill="currentColor">
      <path
        fillRule="evenodd"
        d="M12 1.5c.4.24 1.67 1.04 2.06 1.1s1.6.01 2.05 0c.14.34.72 1.32.9 1.62.3.5 1.47 1.02 2.05 1.33l-.01 1.12c-.02.84-.05 1.1.43 1.84.23.35.52.72.66 1.11-.22.66-.87 1.33-1.03 1.86-.15.46-.04 1.69-.05 2.24-.5.38-1 .6-1.55.87-.4.21-.6.64-.79 1.03l-.62 1.03c-.6.03-1.18-.03-1.77 0-.96.06-1.49.83-2.36 1.11-.36-.13-.83-.45-1.14-.68-.84-.61-1.8-.42-2.86-.41-.23-.24-.44-.72-.66-1.07l-.09-.14c-.74-1.36-1.63-.98-2.3-1.85-.02-2.17.17-2.03-1.05-3.94.34-.71 1.05-1.6 1.07-2.32.02-.52-.07-1.21.01-1.74.3-.28.82-.52 1.2-.7.97-.47 1.24-1.45 1.76-2.3.58 0 1.6.06 2.13-.04.47-.09 1.46-.84 1.96-1.07m3.47 7.74c-.24-1.92-1.99-3.28-3.9-3.03-1.9.24-3.25 1.98-3.02 3.88.24 1.9 1.97 3.26 3.87 3.03 1.92-.22 3.29-1.97 3.05-3.88"
      />
      <path
        d="M7.22 15.46c.25.35.5.94.75 1.2 1.06 0 2.02-.2 2.86.42.31.23.79.55 1.14.68.87-.28 1.4-1.06 2.36-1.1.59-.04 1.18.02 1.77-.01l.62-1.03c.24.58.58 1.13.85 1.69l.88 1.74c.13.27.37.82.58 1.02-.63.5-1.81.98-2.54 1.37-.62.33-1.55.86-2.21 1-.2-.3-.45-.85-.63-1.18q-.52-.97-1.07-1.92c-.15-.26-.44-.8-.63-1l-1.38 2.56c-.26.47-.62 1.18-.9 1.6-.55-.22-1.23-.59-1.77-.87-.8-.43-2.19-.98-2.86-1.53.17-.28.6-1.23.77-1.55.38-.77 1.27-2.31 1.4-3.09"
        opacity=".5"
      />
    </g>
  </SvgIcon>
);

export default HabilitationIcon;
